<template>
    <div class="app-container">
      <BjDivider right-fixed>{{ $t('billingPage.BillingRegularSurcharge') }}
        <template #right>
          <el-button type="primary" plain @click="onSave">{{ $t('saveText') }}</el-button>
        </template>
      </BjDivider>
      <el-form ref="saveForm" size="mini" :model="queryParams" :rules="rules" class="bj-query-form bj-query-form-for-cal-height">
        <el-row :gutter="20" style="padding: 0 10px">
            <!-- 获取所有客户信息列表 -->
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.userName')" prop="clientCode">
                    <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" />
                </el-form-item>
            </el-col>
            <!-- 获取所有Regular Surcharge收费项 -->
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.BillingCategories')" prop="billCategoryCode">
                    <BjSelectLov v-model="queryParams.billCategoryCode" :option-list="billCategoryCodeList" :placeholder="$t('chooseText')" />
                </el-form-item>
            </el-col>
            <!-- 数据字典 key: BILL_REGULAR_SURCHARGE_SOURCE -->
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.BasedSource')" prop="basedSource">
                    <BjSelectLov v-model="queryParams.basedSource" :option-list="basedSourceList" :placeholder="$t('chooseText')" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('billingPage.Date')" prop="queryParamsTime">
                <BjDateRangePicker v-model="queryParamsTime" :placeholder="$t('billingPage.Date')" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.ChargeValue')" prop="chargeValue">
                    <BjInputMoney v-model="queryParams.chargeValue" :placeholder="$t('inputText')" clearable />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.CoverageRate')" prop="chargeRate">
                    <BjInputMoney v-model.number="queryParams.chargeRate" :min="0" :max="100" :placeholder="$t('inputText')" clearable />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.state')" prop="state">
                    <BjSelectLov v-model="queryParams.state" :option-list="ORDER_ACTIVE_TYPE" :placeholder="$t('chooseText')" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.Coments')" prop="description">
                    <BjInput v-model="queryParams.description" type="textarea" show-word-limit autosize :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" />
                </el-form-item>
            </el-col>
        </el-row>
      </el-form>

      <!-- 展示列表 -->
      <BjDivider right-fixed>{{ $t('billingPage.RegularRules') }}</BjDivider>
      <BjPage ref="BjPage"
        :label-width="'80px'"
        :query-params="queryParams" :col-span="colSpan"
        :get-action="queryApi" :serial="false"
        :right-toolbar-hide="true"
        :search-btn-hide="true"
        @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                  <template v-if="col.prop == 'clientCode'">
                    <span style="color: #3173d0;">{{ scope.row.clientCode }}</span>
                    <BjCopyIcon :copy="scope.row.clientCode" />
                  </template>
                  <template v-else-if="col.prop == 'chargeRate'">{{ scope.row.chargeRate }} %</template>
                  <template v-else-if="col.prop == 'state'">
                    <el-tag :type="scope.row.state == 'ACTIVE' ? 'success' : 'info'">
                      {{ scope.row.state=='ACTIVE' ? $t('billingPage.ACTIVE') : $t('billingPage.UNACTIVE') }}
                    </el-tag>
                  </template>
                  <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
              </template>

            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" :disabled="scope.row.state=='ACTIVE'" @click="onDel(scope.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>

      <!-- 弹出框 -->
      <el-dialog :title="$t('billingPage.EditSurcharge')" :visible.sync="dialogFormVisible" width="800px">
        <el-form size="mini" class="bj-query-form bj-query-form-for-cal-height">
          <el-row :gutter="20" style="padding: 0 10px">
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.userName')">
                      <BjSelectLov v-model="form.clientCode" disabled :option-list="clientCodeList" :placeholder="$t('chooseText')" />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.BillingCategories')">
                      <BjSelectLov v-model="form.billCategoryCode" disabled :option-list="billCategoryCodeList" :placeholder="$t('chooseText')" />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.BasedSource')">
                      <BjSelectLov v-model="form.basedSource" disabled lov-code="BILL_REGULAR_SURCHARGE_SOURCE" :placeholder="$t('chooseText')" />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.ChargeValue')">
                      <BjInputMoney v-model="form.chargeValue" :placeholder="$t('inputText')" clearable />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.CoverageRate')">
                      <BjInputMoney v-model.number="form.chargeRate" :min="0" :max="100" :placeholder="$t('inputText')" clearable />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS">
                  <el-form-item :label="$t('billingPage.state')">
                      <BjSelectLov v-model="form.state" :option-list="ORDER_ACTIVE_TYPE" :placeholder="$t('chooseText')" />
                  </el-form-item>
              </el-col>
              <el-col :span="colSpanS*2">
                  <el-form-item :label="$t('billingPage.Coments')">
                      <BjInput v-model="form.description" type="textarea" autosize show-word-limit :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" />
                  </el-form-item>
              </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import { billApi } from '@/api';
import { ORDER_ACTIVE_TYPE } from '@/utils/constants';
import pageMiXin from '@/utils/page-mixin.js';
export default {
  name: 'BusinessBillingRegularSurcharge',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      colSpanS: 8,
      ORDER_ACTIVE_TYPE,
      queryParamsTime: [],
      queryApi: billApi.getRegularSurchargeList,
      queryParams: {
        clientCode: null,
        billCategoryCode: null,
        basedSource: null,
        chargeValue: null,
        chargeRate: '100',
        startDate: null,
        endDate: null,
        state: null,
        description: null,
      },
      labelList: [
        { label: this.$t('billingPage.clientCode'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.billCategoryCode'), prop: 'billCategoryCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.ChargeValue'), prop: 'chargeValue', isCheck: true, disabled: false },
        { label: this.$t('billingPage.CoverageRate'), prop: 'chargeRate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.endDate'), prop: 'endDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Coments'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Submitter'), prop: 'createdBy', isCheck: true, disabled: false },
        { label: this.$t('billingPage.state'), prop: 'state', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      tableData: [],
      // 编辑栏 数据
      form: {},
      dialogFormVisible: false,
      // 下拉搜索列表
      clientCodeList: [],
      billCategoryCodeList: [],
      basedSourceList: [],
      rules: {
        clientCode: [{required: true, message: this.$t('chooseText'), trigger: 'change'}],
        billCategoryCode: [{required: true, message: this.$t('chooseText'), trigger: 'change'}],
        basedSource: [{required: true, message: this.$t('chooseText'), trigger: 'change'}],
        chargeValue: [{required: true, message: this.$t('inputText'), trigger: 'blur'}],
        chargeRate: [{required: true, message: this.$t('inputText'), trigger: 'blur'}],
      },
    };
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.startDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    },
  },
  mounted() {
    this._getRegularSurchargeType();
    this.getClientInfoList();
    this.getAllRegularSurcharges();
  },
  methods: {
    _getRegularSurchargeType(){
      billApi.getRegularSurchargeType().then(res=>{
        this.basedSourceList = res.data;
      })
    },
    // 获取所有客户信息列表
    getClientInfoList() {
      billApi.getClientInfoList().then(res => {
        res.data.forEach(item => {
          item.label = `${item.label} - ${item.value}`;
        });
        this.clientCodeList = res.data;
      });
    },
    // 获取所有Regular Surcharge收费项
    getAllRegularSurcharges() {
      billApi.getAllRegularSurcharges().then(res => {
        this.billCategoryCodeList = res.data;
      });
    },
    // 新增按钮
    onSave() {
      this.$refs.saveForm.validate(valid => {
        if (valid) {
          billApi.addRegularSurchargeList(this.queryParams).then(res => {
            if (res.code === 200) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.queryParamsTime = [];
              this.$refs.saveForm.resetFields();
              this.reFresh();
            }
          });
        }
      });
    },
    // 编辑按钮 打开弹出框
    onEdit(row) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
      this.$set(this.form, 'basedSource', row.basedSource + '');
    },
    // 弹出框保存按钮
    saveAmount() {
      billApi.updateRegularSurchargeList(this.form).then(res => {
        if (res.code === 200) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.dialogFormVisible = false;
          this.reFresh();
        }
      });
    },
    // 删除按钮
    onDel(row) {
      billApi.deleteRegularSurchargeList({id: row.id}).then(res => {
        if (res.code === 200) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
  },
};
</script>
